import { render, staticRenderFns } from "./DidDetails.vue?vue&type=template&id=718222b4&scoped=true&"
import script from "./DidDetails.vue?vue&type=script&lang=js&"
export * from "./DidDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718222b4",
  null
  
)

export default component.exports